import React from "react";

const VideoPlayer = () => {
  return <div className="text-center m-10 text-2xl">Video Player</div>;
};

export default VideoPlayer;
